import { apiMindbox, MINDBOX_OPERATIONS } from '@/fo/api/mindbox';

export const mindboxViewCategory = async (id: string) => {
  return await apiMindbox(MINDBOX_OPERATIONS.VIEW_CATEGORY, {
    viewProductCategory: {
      productCategory: {
        ids: {
          bitrixProducts: id
        }
      }
    }
  });
};
